/* tslint:disable */

export class TextInput extends PIXI.Container {

  private _input_style: any;
  private _box_generator: any;

  private _box_cache;
  private _previous;
  private _dom_added;
  private _dom_visible;
  private _placeholder;
  private _placeholderColor;
  private _selection;
  private _restrict_value;
  private _substituted;
  private _multiline;

  constructor(styles) {
    super();
    (this as any)._input_style = Object.assign(
      {
        position: "absolute",
        background: "none",
        border: "none",
        outline: "none",
        transformOrigin: "0 0",
        lineHeight: "1"
      },
      styles.input
    );

    if (styles.box) {
      (this as any)._box_generator = typeof styles.box === "function" ? styles.box : DefaultBoxGenerator(styles.box);
    } else {
      (this as any)._box_generator = null;
    }

    if ((this as any)._input_style.hasOwnProperty("multiline")) {
      (this as any)._multiline = !!(this as any)._input_style.multiline;
      delete (this as any)._input_style.multiline;
    } else {
      (this as any)._multiline = false;
    }

    (this as any)._box_cache = {};
    (this as any)._previous = {};
    (this as any)._dom_added = false;
    (this as any)._dom_visible = true;
    (this as any)._placeholder = "";
    (this as any)._placeholderColor = 0xa9a9a9;
    (this as any)._selection = [0, 0];
    (this as any)._restrict_value = "";
    (this as any)._createDOMInput();
    (this as any).substituteText = true;
    (this as any)._setState("DEFAULT");
    (this as any)._addListeners();
  }


  // GETTERS & SETTERS

  get substituteText() {
    return (this as any)._substituted;
  }

  set substituteText(substitute) {
    if ((this as any)._substituted == substitute) {
      return;
    }

    (this as any)._substituted = substitute;

    if (substitute) {
      (this as any)._createSurrogate();
      (this as any)._dom_visible = false;
    } else {
      (this as any)._destroySurrogate();
      (this as any)._dom_visible = true;
    }
    (this as any).placeholder = (this as any)._placeholder;
    (this as any)._update();
  }

  get placeholder() {
    return (this as any)._placeholder;
  }

  set placeholder(text) {
    (this as any)._placeholder = text;
    if ((this as any)._substituted) {
      (this as any)._updateSurrogate();
      (this as any)._dom_input.placeholder = "";
    } else {
      (this as any)._dom_input.placeholder = text;
    }
  }

  get disabled() {
    return (this as any)._disabled;
  }

  set disabled(disabled) {
    (this as any)._disabled = disabled;
    (this as any)._dom_input.disabled = disabled;
    (this as any)._setState(disabled ? "DISABLED" : "DEFAULT");
  }

  get maxLength() {
    return (this as any)._max_length;
  }

  set maxLength(length) {
    (this as any)._max_length = length;
    (this as any)._dom_input.setAttribute("maxlength", length);
  }

  get restrict() {
    return (this as any)._restrict_regex;
  }

  set restrict(regex) {
    if (regex instanceof RegExp) {
      regex = regex.toString().slice(1, -1);

      if (regex.charAt(0) !== "^") {
        regex = "^" + regex;
      }

      if (regex.charAt(regex.length - 1) !== "$") {
        regex = regex + "$";
      }

      regex = new RegExp(regex);
    } else {
      regex = new RegExp("^[" + regex + "]*$");
    }

    (this as any)._restrict_regex = regex;
  }

  get text() {
    return (this as any)._dom_input.value;
  }

  set text(text) {
    (this as any)._dom_input.value = text;
    if ((this as any)._substituted) {
      (this as any)._updateSurrogate();
    }
  }

  get htmlInput() {
    return (this as any)._dom_input;
  }

  focus() {
    if ((this as any)._substituted && !(this as any).dom_visible) {
      (this as any)._setDOMInputVisible(true);
    }

    (this as any)._dom_input.focus();

  }

  blur() {
    (this as any)._dom_input.blur();
  }

  select() {
    (this as any).focus();
    (this as any)._dom_input.select();
  }

  setInputStyle(key, value) {
    (this as any)._input_style[key] = value;
    (this as any)._dom_input.style[key] = value;

    if ((this as any)._substituted && (key === "fontFamily" || key === "fontSize")) {
      (this as any)._updateFontMetrics();
    }

    if ((this as any)._last_renderer) {
      (this as any)._update();
    }
  }

  destroy() {
    (this as any)._destroyBoxCache();
    super.destroy();
  }


  // SETUP

  _createDOMInput() {
    if ((this as any)._multiline) {
      (this as any)._dom_input = document.createElement("textarea");
      (this as any)._dom_input.style.resize = "none";
    } else {
      (this as any)._dom_input = document.createElement("input");
      (this as any)._dom_input.type = "text";
    }

    for (const key in (this as any)._input_style) {
      (this as any)._dom_input.style[key] = (this as any)._input_style[key];
    }
  }

  _addListeners() {
    (this as any).on("added", (this as any)._onAdded.bind(this));
    (this as any).on("removed", (this as any)._onRemoved.bind(this));
    (this as any)._dom_input.addEventListener("keydown", (this as any)._onInputKeyDown.bind(this));
    (this as any)._dom_input.addEventListener("input", (this as any)._onInputInput.bind(this));
    (this as any)._dom_input.addEventListener("keyup", (this as any)._onInputKeyUp.bind(this));
    (this as any)._dom_input.addEventListener("focus", (this as any)._onFocused.bind(this));
    (this as any)._dom_input.addEventListener("blur", (this as any)._onBlurred.bind(this));
  }

  _onInputKeyDown(e) {
    (this as any)._selection = [
      (this as any)._dom_input.selectionStart,
      (this as any)._dom_input.selectionEnd
    ];

    (this as any).emit("keydown", e.keyCode);
  }

  _onInputInput(e) {
    if ((this as any)._restrict_regex) {
      (this as any)._applyRestriction();
    }

    if ((this as any)._substituted) {
      (this as any)._updateSubstitution();
    }

    (this as any).emit("input", (this as any).text);
  }

  _onInputKeyUp(e) {
    (this as any).emit("keyup", e.keyCode);
  }

  _onFocused() {
    (this as any)._setState("FOCUSED");
    (this as any).emit("focus");
  }

  _onBlurred() {
    (this as any)._setState("DEFAULT");
    (this as any).emit("blur");
  }

  _onAdded() {
    document.body.appendChild((this as any)._dom_input);
    (this as any)._dom_input.style.display = "none";
    (this as any)._dom_added = true;
  }

  _onRemoved() {
    document.body.removeChild((this as any)._dom_input);
    (this as any)._dom_added = false;
  }

  _setState(state) {
    (this as any).state = state;
    (this as any)._updateBox();
    if ((this as any)._substituted) {
      (this as any)._updateSubstitution();
    }
  }


  // RENDER & UPDATE

  // for pixi v4
  renderWebGL(renderer) {
    super.renderWebGL(renderer);
    (this as any)._renderInternal(renderer);
  }

  // for pixi v4
  renderCanvas(renderer) {
    super.renderCanvas(renderer);
    (this as any)._renderInternal(renderer);
  }

  // for pixi v5
  render(renderer) {
    this.render(renderer);
    (this as any)._renderInternal(renderer);
  }

  _renderInternal(renderer) {
    (this as any)._resolution = renderer.resolution;
    (this as any)._last_renderer = renderer;
    (this as any)._canvas_bounds = (this as any)._getCanvasBounds();
    if ((this as any)._needsUpdate()) {
      (this as any)._update();
    }
  }

  _update() {
    (this as any)._updateDOMInput();
    if ((this as any)._substituted) {
      (this as any)._updateSurrogate();
    }
    (this as any)._updateBox();
  }

  _updateBox() {
    if (!(this as any)._box_generator) {
      return;
    }

    if ((this as any)._needsNewBoxCache()) {
      (this as any)._buildBoxCache();
    }

    if ((this as any).state == (this as any)._previous.state
      && (this as any)._box == (this as any)._box_cache[(this as any).state]) {
      return;
    }

    if ((this as any)._box) {
      (this as any).removeChild((this as any)._box);
    }

    (this as any)._box = (this as any)._box_cache[(this as any).state];
    (this as any).addChildAt((this as any)._box, 0);
    (this as any)._previous.state = (this as any).state;
  }

  _updateSubstitution() {
    if ((this as any).state === "FOCUSED") {
      (this as any)._dom_visible = true;
      (this as any)._surrogate.visible = (this as any).text.length === 0;
    } else {
      (this as any)._dom_visible = false;
      (this as any)._surrogate.visible = true;
    }
    (this as any)._updateDOMInput();
    (this as any)._updateSurrogate();
  }

  _updateDOMInput() {
    if (!(this as any)._canvas_bounds) {
      return;
    }

    (this as any)._dom_input.style.top = (this as any)._canvas_bounds.top + "px";
    (this as any)._dom_input.style.left = (this as any)._canvas_bounds.left + "px";
    (this as any)._dom_input.style.transform = (this as any)._pixiMatrixToCSS((this as any)._getDOMRelativeWorldTransform());
    (this as any)._dom_input.style.opacity = (this as any).worldAlpha;
    (this as any)._setDOMInputVisible((this as any).worldVisible && (this as any)._dom_visible);

    (this as any)._previous.canvas_bounds = (this as any)._canvas_bounds;
    (this as any)._previous.world_transform = (this as any).worldTransform.clone();
    (this as any)._previous.world_alpha = (this as any).worldAlpha;
    (this as any)._previous.world_visible = (this as any).worldVisible;
  }

  _applyRestriction() {
    if ((this as any)._restrict_regex.test((this as any).text)) {
      (this as any)._restrict_value = (this as any).text;
    } else {
      (this as any).text = (this as any)._restrict_value;
      (this as any)._dom_input.setSelectionRange(
        (this as any)._selection[0],
        (this as any)._selection[1]
      );
    }
  }


  // STATE COMPAIRSON (FOR PERFORMANCE BENEFITS)

  _needsUpdate() {
    return (
      !(this as any)._comparePixiMatrices((this as any).worldTransform, (this as any)._previous.world_transform)
      || !(this as any)._compareClientRects((this as any)._canvas_bounds, (this as any)._previous.canvas_bounds)
      || (this as any).worldAlpha != (this as any)._previous.world_alpha
      || (this as any).worldVisible != (this as any)._previous.world_visible
    );
  }

  _needsNewBoxCache() {
    const input_bounds = (this as any)._getDOMInputBounds();
    return (
      !(this as any)._previous.input_bounds
      || input_bounds.width != (this as any)._previous.input_bounds.width
      || input_bounds.height != (this as any)._previous.input_bounds.height
    );
  }


  // INPUT SUBSTITUTION

  _createSurrogate() {
    (this as any)._surrogate_hitbox = new PIXI.Graphics();
    (this as any)._surrogate_hitbox.alpha = 0;
    (this as any)._surrogate_hitbox.interactive = true;
    (this as any)._surrogate_hitbox.cursor = "text";
    (this as any)._surrogate_hitbox.on("pointerdown", (this as any)._onSurrogateFocus.bind(this));
    (this as any).addChild((this as any)._surrogate_hitbox);

    (this as any)._surrogate_mask = new PIXI.Graphics();
    (this as any).addChild((this as any)._surrogate_mask);

    (this as any)._surrogate = new PIXI.Text("", {});
    (this as any).addChild((this as any)._surrogate);

    (this as any)._surrogate.mask = (this as any)._surrogate_mask;

    (this as any)._updateFontMetrics();
    (this as any)._updateSurrogate();
  }

  _updateSurrogate() {
    const padding = (this as any)._deriveSurrogatePadding();
    const input_bounds = (this as any)._getDOMInputBounds();

    (this as any)._surrogate.style = (this as any)._deriveSurrogateStyle();
    (this as any)._surrogate.style.padding = Math.max.apply(Math, padding);
    (this as any)._surrogate.y = (this as any)._multiline ? padding[0] : (input_bounds.height - (this as any)._surrogate.height) / 2;
    (this as any)._surrogate.x = padding[3];
    (this as any)._surrogate.text = (this as any)._deriveSurrogateText();

    (this as any)._updateSurrogateHitbox(input_bounds);
    (this as any)._updateSurrogateMask(input_bounds, padding);
  }

  _updateSurrogateHitbox(bounds) {
    (this as any)._surrogate_hitbox.clear();
    (this as any)._surrogate_hitbox.beginFill(0);
    (this as any)._surrogate_hitbox.drawRect(0, 0, bounds.width, bounds.height);
    (this as any)._surrogate_hitbox.endFill();
    (this as any)._surrogate_hitbox.interactive = !(this as any)._disabled;
  }

  _updateSurrogateMask(bounds, padding) {
    (this as any)._surrogate_mask.clear();
    (this as any)._surrogate_mask.beginFill(0);
    (this as any)._surrogate_mask.drawRect(padding[3], 0, bounds.width - padding[3] - padding[1], bounds.height);
    (this as any)._surrogate_mask.endFill();
  }

  _destroySurrogate() {
    if (!(this as any)._surrogate) {
      return;
    }

    (this as any).removeChild((this as any)._surrogate);
    (this as any).removeChild((this as any)._surrogate_hitbox);

    (this as any)._surrogate.destroy();
    (this as any)._surrogate_hitbox.destroy();

    (this as any)._surrogate = null;
    (this as any)._surrogate_hitbox = null;
  }

  _onSurrogateFocus() {
    (this as any)._setDOMInputVisible(true);
    //sometimes the input is not being focused by the mouseclick
    setTimeout((this as any)._ensureFocus.bind(this), 10);
  }

  _ensureFocus() {
    if (!(this as any)._hasFocus()) {
      (this as any).focus();
    }
  }

  _deriveSurrogateStyle() {
    const style = new PIXI.TextStyle({});

    for (const key in (this as any)._input_style) {
      switch (key) {
        case "color":
          style.fill = (this as any)._input_style.color;
          break;
        case "fontFamily":
        case "fontSize":
        case "fontWeight":
        case "fontVariant":
        case "fontStyle":
          style[key] = (this as any)._input_style[key];
          break;
        case "letterSpacing":
          style.letterSpacing = parseFloat((this as any)._input_style.letterSpacing);
          break;
      }
    }

    if ((this as any)._multiline) {
      style.lineHeight = parseFloat((style.fontSize as any));
      style.wordWrap = true;
      style.wordWrapWidth = (this as any)._getDOMInputBounds().width;
    }

    if ((this as any)._dom_input.value.length === 0) {
      style.fill = (this as any)._placeholderColor;
    }

    return style;
  }

  _deriveSurrogatePadding() {
    const indent = (this as any)._input_style.textIndent ? parseFloat((this as any)._input_style.textIndent) : 0;

    if ((this as any)._input_style.padding && (this as any)._input_style.padding.length > 0) {
      const components = (this as any)._input_style.padding.trim().split(" ");

      if (components.length == 1) {
        const padding = parseFloat(components[0]);
        return [padding, padding, padding, padding + indent];
      } else if (components.length == 2) {
        const paddingV = parseFloat(components[0]);
        const paddingH = parseFloat(components[1]);
        return [paddingV, paddingH, paddingV, paddingH + indent];
      } else if (components.length == 4) {
        const padding = components.map(component => {
          return parseFloat(component);
        });
        padding[3] += indent;
        return padding;
      }
    }

    return [0, 0, 0, indent];
  }

  _deriveSurrogateText() {
    return (this as any)._dom_input.value.length === 0 ? (this as any)._placeholder : (this as any)._dom_input.value;
  }

  _updateFontMetrics() {
    const style = (this as any)._deriveSurrogateStyle();
    const font = style.toFontString();

    (this as any)._font_metrics = PIXI.TextMetrics.measureFont(font);
  }


  // CACHING OF INPUT BOX GRAPHICS

  _buildBoxCache() {
    (this as any)._destroyBoxCache();

    const states = ["DEFAULT", "FOCUSED", "DISABLED"];
    const input_bounds = (this as any)._getDOMInputBounds();

    for (const i in states) {
      (this as any)._box_cache[states[i]] = (this as any)._box_generator(
        input_bounds.width,
        input_bounds.height,
        states[i]
      );
    }

    (this as any)._previous.input_bounds = input_bounds;
  }

  _destroyBoxCache() {
    if ((this as any)._box) {
      (this as any).removeChild((this as any)._box);
      (this as any)._box = null;
    }

    for (const i in (this as any)._box_cache) {
      (this as any)._box_cache[i].destroy();
      (this as any)._box_cache[i] = null;
      delete (this as any)._box_cache[i];
    }
  }


  // HELPER FUNCTIONS

  _hasFocus() {
    return document.activeElement === (this as any)._dom_input;
  }

  _setDOMInputVisible(visible) {
    (this as any)._dom_input.style.display = visible ? "block" : "none";
  }

  _getCanvasBounds() {
    const rect = (this as any)._last_renderer.view.getBoundingClientRect();
    const bounds = {top: rect.top, left: rect.left, width: rect.width, height: rect.height};
    bounds.left += window.scrollX;
    bounds.top += window.scrollY;
    return bounds;
  }

  _getDOMInputBounds() {
    let remove_after = false;

    if (!(this as any)._dom_added) {
      document.body.appendChild((this as any)._dom_input);
      remove_after = true;
    }

    const org_transform = (this as any)._dom_input.style.transform;
    const org_display = (this as any)._dom_input.style.display;
    (this as any)._dom_input.style.transform = "";
    (this as any)._dom_input.style.display = "block";
    const bounds = (this as any)._dom_input.getBoundingClientRect();
    (this as any)._dom_input.style.transform = org_transform;
    (this as any)._dom_input.style.display = org_display;

    if (remove_after) {
      document.body.removeChild((this as any)._dom_input);
    }

    return bounds;
  }

  _getDOMRelativeWorldTransform() {
    const canvas_bounds = (this as any)._last_renderer.view.getBoundingClientRect();
    const matrix = (this as any).worldTransform.clone();

    matrix.scale((this as any)._resolution, (this as any)._resolution);
    matrix.scale(canvas_bounds.width / (this as any)._last_renderer.width,
      canvas_bounds.height / (this as any)._last_renderer.height);
    return matrix;
  }

  _pixiMatrixToCSS(m) {
    return "matrix(" + [m.a, m.b, m.c, m.d, m.tx, m.ty].join(",") + ")";
  }

  _comparePixiMatrices(m1, m2) {
    if (!m1 || !m2) {
      return false;
    }
    return (
      m1.a == m2.a
      && m1.b == m2.b
      && m1.c == m2.c
      && m1.d == m2.d
      && m1.tx == m2.tx
      && m1.ty == m2.ty
    );
  }

  _compareClientRects(r1, r2) {
    if (!r1 || !r2) {
      return false;
    }
    return (
      r1.left == r2.left
      && r1.top == r2.top
      && r1.width == r2.width
      && r1.height == r2.height
    );
  }
}


function DefaultBoxGenerator(styles) {
  styles = styles || {fill: 0xcccccc};

  if (styles.default) {
    styles.focused = styles.focused || styles.default;
    styles.disabled = styles.disabled || styles.default;
  } else {
    const temp_styles = styles;
    styles = {};
    styles.default = styles.focused = styles.disabled = temp_styles;
  }

  return function (w, h, state) {
    const style = styles[state.toLowerCase()];
    const box = new PIXI.Graphics();

    if (style.fill) {
      box.beginFill(style.fill);
    }

    if (style.stroke) {
      box.lineStyle(
        style.stroke.width || 1,
        style.stroke.color || 0,
        style.stroke.alpha || 1
      );
    }

    if (style.rounded) {
      box.drawRoundedRect(0, 0, w, h, style.rounded);
    } else {
      box.drawRect(0, 0, w, h);
    }

    box.endFill();
    box.closePath();

    return box;
  };
}




// WEBPACK FOOTER //
// ./src/app/PIXI.TextInput.ts